import { channelResponseSchema } from "../campaigns/commonTypes"
import { z } from "zod"

export const NoteResponseDataSchema = z.object({
  id: z.bigint().transform(String),
  text: z.string(),
  createdAt: z.date().transform((value) => value.toISOString()),
  updatedAt: z.date().transform((value) => value.toISOString()),
})

export const NoteEmployeeResponseDataSchema = z.object({
  id: z.bigint().transform(String),
  name: z.string(),
})

export const ConversationNoteResponseDataSchema = z.object({
  id: z.bigint().transform(String),
  createdAt: z.date().transform((value) => value.toISOString()),
  updatedAt: z.date().transform((value) => value.toISOString()),
  text: z.string(),
  employee: NoteEmployeeResponseDataSchema,
  mentions: z.array(NoteEmployeeResponseDataSchema),
})

export const CustomerNoteResponseDataSchema = z.object({
  id: z.bigint().transform(String),
  createdAt: z.date().transform((value) => value.toISOString()),
  updatedAt: z.date().transform((value) => value.toISOString()),
  text: z.string(),
  employee: NoteEmployeeResponseDataSchema,
  mentions: z.array(NoteEmployeeResponseDataSchema),
  conversationId: z.bigint().transform(String).nullable(),
  conversation: z
    .object({
      channel: channelResponseSchema,
      createdAt: z.date().transform((value) => value.toISOString()),
      campaignName: z.string().nullable(),
    })
    .nullable(),
})

export const CustomerNotesResponseDataSchema = z.array(CustomerNoteResponseDataSchema)
